import coreAPIInstance from "./coreApiInstance";

export const coreTagsAPIs = {
  getTags: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/tags/get`, payload, { headers }),
  createTags: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/tags/create`, payload, { headers }),
  updateTags: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/tags/update`, payload, { headers }),
  getTagsByFieldId: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/tags/get-by-field`, payload, { headers }),
};
